import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { InputSize } from '../../enum/input-size.enum';

@Component({
  selector: 'lib-filter-button',
  imports: [MatIcon],
  templateUrl: './filter-button.component.html',
  styleUrl: './filter-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterButtonComponent {
  size = input<InputSize>(InputSize.large);
  hideLeadingIcon = input<boolean>(false);
  disabled = input<boolean>(false);
  badgeCount = input<number | null>();
  buttonClick = output();

  protected readonly InputSize = InputSize;
}
